import $ from 'jquery';

$('.related-button').on('click', (e) => {
  var divId = $(this).data('id');
  $('.related-section').removeClass('active');
  $('#' + divId).toggleClass('active');
});
